(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/challenge/assets/javascripts/components/betslip/betslip-sticky-content-container.js') >= 0) return;  svs.modules.push('/modules/challenge/assets/javascripts/components/betslip/betslip-sticky-content-container.js');
"use strict";


const _ReactRouterDOM = ReactRouterDOM,
  withRouter = _ReactRouterDOM.withRouter;
const _svs$challenge = svs.challenge,
  BetslipStickyContent = _svs$challenge.BetslipStickyContent,
  helpers = _svs$challenge.helpers;
const mapStateToProps = (state, _ref) => {
  let match = _ref.match;
  const drawNumber = Number(match.params.drawNumber);
  const coupon = helpers.getCouponByDrawNumber(state, drawNumber);
  return {
    betSum: coupon.betSum,
    drawEvents: coupon.drawEvents,
    hasActionbar: coupon.hasActionbar,
    isLoggedIn: state.isLoggedIn,
    isPayable: coupon.isPayable,
    rowPrice: coupon.chosenBetPrice
  };
};
svs.challenge.BetslipStickyContentContainer = withRouter(ReactRedux.connect(mapStateToProps)(BetslipStickyContent));

 })(window);